/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { StackItem } from '@fluentui/react/lib/Stack';
import * as React from 'react';
import { defineMessages } from 'react-intl';
import { useHistory } from 'react-router';
import { Page } from 'src/core/components/Page';
import { useLocalization } from 'src/core/hooks/useLocalization';
import { routeTable } from 'src/core/utils/routeTable';
import { useCurrentVersionedAppId } from 'src/luis/modules/apps/hooks/useCurrentVersionedAppId';
import { PublishCard } from 'src/luis/projects/analytics/components/PublishCard/PublishCard';
import { TrainingEvaluation } from 'src/luis/projects/analytics/components/TrainingEvaluation/TrainingEvaluation';
import { PassedFilters } from 'src/luis/projects/analytics/types/PassedFilters';
import { LuisId } from 'src/luis/types/Resource';

const messages = defineMessages({
    title: {
        id: 'luis.dashboardPane.title',
        defaultMessage: 'LUIS: Dashboard'
    }
});

export const DashboardPane = () => {
    const { localize } = useLocalization();
    const history = useHistory();
    const { appId, versionId } = useCurrentVersionedAppId();

    const onIntentClick = (intentId: LuisId, passedFilters: PassedFilters) => {
        history.push(routeTable.luis.intentPage(appId, versionId, intentId), passedFilters);
    };

    return (
        <Page pageName="DashboardPanePage" title={localize(messages.title)}>
            <StackItem verticalFill>
                <PublishCard />

                <TrainingEvaluation onIntentClick={onIntentClick} />
            </StackItem>
        </Page>
    );
};
